module.exports = __webpack_public_path__ + "img/38.a7ea20c7.png";